import { alpha, createStyles, makeStyles, Theme } from '@material-ui/core';
import commonStyles from 'config/commonStyles';

const styles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        root: {
            minWidth: 500,
            padding: '15px 30px',
            display: 'inline-block',
            maxHeight: '100%',
            overflowY: 'auto',
            '& form': {
                display: 'flex',
                flexGrow: 1,
                justifyContent: 'space-between',
            },
            '& form>div:last-child': {
                display: 'flex',
                alignItems: 'center',
            },
        },
        pricesContainer: {
            padding: '10px 20px',
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: 5,
            marginTop: 10,
            maxWidth: 600,
        },
        priceItemContainer: {
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        priceItemHeaderContainer: {
            display: 'flex',
            flexGrow: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 0',
        },
        priceItemActions: {
            display: 'flex',
            alignItems: 'center',
            gap: 14,
        },
        priceItemContainerEdit: {
            display: 'flex',
            flexGrow: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px',
            backgroundColor: theme.palette.grey[100],
            borderRadius: 5,
        },
        keyIconWrapper: {
            position: 'relative',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: 'rotate(135deg)',
        },
        keyIconStatusDot: {
            position: 'absolute',
            width: 7,
            height: 7,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main,
            border: `1px solid ${theme.palette.common.white}`,
            top: 0,
            right: -1,
            transform: 'rotate(-135deg)',
        },
        accessPanelContainer: {
            marginTop: 8,
            marginBottom: 8,
            padding: 16,
            borderRadius: 8,
            backgroundColor: alpha(theme.palette.success.light, 0.3),
            border: `1px solid ${theme.palette.success.main}`,
        },
        notGeneratedContainer: {
            minHeight: 74,
            borderRadius: 8,
            border: `1px dashed ${theme.palette.warning.main}`,
            backgroundColor: alpha(theme.palette.warning.main, 0.05),
            padding: 16,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 16,
            marginBottom: 10,
        },
        sectionDescription: {
            color: theme.palette.text.secondary,
            fontSize: 14,
            maxWidth: 680,
            margin: '6px 0 4px',
        },
        notGeneratedText: {
            color: theme.palette.text.secondary,
            fontSize: 14,
            maxWidth: 680,
        },
        notGeneratedActionButton: {
            flexShrink: 0,
            whiteSpace: 'nowrap',
        },
        generatedStateContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: 18,
            padding: 16,
        },
        qrPreviewContainer: {
            width: 128,
            height: 128,
            borderRadius: 8,
            border: `1px solid ${theme.palette.grey[300]}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: theme.palette.common.white,
            flexShrink: 0,
            '& canvas': {
                width: 96,
                height: 96,
            },
        },
        generatedContentContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            minWidth: 0,
        },
        accessCodeLabel: {
            color: theme.palette.text.secondary,
            fontSize: 14,
        },
        accessCodeChip: {
            alignSelf: 'flex-start',
            padding: '5px 12px',
            borderRadius: 8,
            fontWeight: 700,
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.common.white,
            border: `1px solid ${theme.palette.grey[300]}`,
            letterSpacing: 1,
        },
        generatedMetaText: {
            color: theme.palette.text.secondary,
            fontSize: 14,
        },
        generatedActionsRow: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            '& button': {
                minWidth: 158,
                backgroundColor: theme.palette.common.white,
            },
        },
        regenerateWarningContainer: {
            marginTop: 14,
            borderRadius: 8,
            backgroundColor: alpha(theme.palette.error.light, 0.1),
            border: `1px solid ${theme.palette.error.main}`,
            padding: 16,
        },
        regenerateWarningText: {
            color: theme.palette.error.main,
            fontSize: 14,
        },
        regenerateWarningActions: {
            marginTop: 14,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
        },
        [theme.breakpoints.down('md')]: {
            root: {
                minWidth: 0,
                width: '100%',
                padding: '15px',
            },
            generatedActionsRow: {
                width: '100%',
                flexWrap: 'wrap',
                '& button': {
                    minWidth: 0,
                },
            },
        },
    })
);

export default styles;
